import React from "react";
import AppBar from "@mui/material/AppBar";

import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import Copyright from "./Copyright";
import { IconButton } from "@mui/material";
import ExitToApp from "@mui/icons-material/ExitToApp";
import auth from "../services/auth";
import { useNavigate } from "react-router-dom";

export default function TemplateUsers({ children }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    auth.logout(() => {
      navigate("/");
    });
  };

  return (
    <>
      <CssBaseline />
      <AppBar position="relative" color="neutral" elevation={0}>
        <Toolbar>
          <Box sx={{ flex: 1 }} />
          <Typography
            component="p"
            variant="subtitle1"
            color="primary"
            noWrap
           
          >
            Olá, Cliente!
          </Typography>
          <IconButton onClick={handleLogout} color="primary">
            <ExitToApp />
          </IconButton>
        </Toolbar>
      </AppBar>
      <main>{children}</main>

      <Box sx={{ bgcolor: "background.paper", p: 6 }} component="footer">
        <Copyright />
      </Box>
    </>
  );
}
